import React from 'react';
import { Box } from '@mui/material';
import { useSwipeGestures } from '../hooks/useGestures';

export default function GestureWrapper({ enabled = true, onSwipeLeft, onSwipeRight, children, sx }) {
  const bind = useSwipeGestures({ enabled, onSwipeLeft, onSwipeRight });
  return (
    <Box {...bind()} sx={sx}>
      {children}
    </Box>
  );
}



